import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyCostAddComponent } from './company-cost-add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OpsNumberDirective } from '../directives/ops-number.directive';
import { FinanceDropdownModule } from '../finance-dropdown/finance-dropdown.module';
import { BigNumberPipe } from '../pipes/big-number.pipe';
import { NumberOnlyDirective } from '../directives/number-only.directive';
import { EnterPressDirective } from '../directives/enter-press.directive';
import { OpsCalendarComponent, OpsCustomCurrencyModalComponent } from '@ops/storybook';
import { TranslateModule } from '@ngx-translate/core';
import { BankAccountCreateModalComponent } from '../bank-account-create-modal/bank-account-create-modal.component';
import { CreditCardCreateModalComponent } from '../credit-card-create-modal/credit-card-create-modal.component';
import { NumericInputComponent } from '../numeric-input/numeric-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FinanceDropdownModule,
    OpsNumberDirective,
    BigNumberPipe,
    NumberOnlyDirective,
    EnterPressDirective,
    OpsCalendarComponent,
    TranslateModule,
    BankAccountCreateModalComponent,
    CreditCardCreateModalComponent,
    OpsCustomCurrencyModalComponent,
    NumericInputComponent,
  ],
  exports: [CompanyCostAddComponent],
  declarations: [CompanyCostAddComponent],
})
export class CompanyCostAddModule {}
